import { render, staticRenderFns } from "./addorder2.vue?vue&type=template&id=73683364&"
import script from "./addorder2.vue?vue&type=script&lang=js&"
export * from "./addorder2.vue?vue&type=script&lang=js&"
import style0 from "./addorder2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports